import React, {Component} from 'react';
import Api from "../utils/Api";
import PropTypes from "prop-types";

class UserNav extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        notifications: PropTypes.array.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

        this.logout = this.logout.bind(this);

    }

    logout(evt) {

        evt.preventDefault();

        new Api().logout(true);

    }

    navigate(pageKey) {

        if (this.props.baseData.pageNavigation) this.props.baseData.pageNavigation(pageKey);

        return null;

    }

    getAlarmCounter() {

        const notificationCount = this.props.notifications.length;

        let counter = notificationCount;

        if (notificationCount > 99) counter = '99+';
        if (notificationCount < 0) counter = 0;

        return counter;

    }

    render() {

        const alarmCounter = this.getAlarmCounter();
        const alarmStyle = (alarmCounter) ? 'block' : 'none';
        const displayName = this.props.baseData.userData ? this.props.baseData.userData.first_name + " " + this.props.baseData.userData.last_name : '';

        return (
            <div>
                {/*<!-- Usernav -->*/}
                <div className="usernav">
                    <div className="userAlarms" style={{display: alarmStyle}}>
                        <div onClick={() => this.navigate('alarms')}>
                            <a href="#alarms" title={this.translate('alarms')}>{this.translate('alarms')}</a>
                            <span className="alarmCounter">{alarmCounter}</span>
                        </div>
                    </div>

                    <div title="Settings" onClick={() => this.navigate('userSettings')}>
                        <div className="openuseracc">{this.translate('openUserSettings')}</div>

                        <p title={this.translate('settings')}>
                            <a href="#user" className="prefs-btn">{displayName}</a>
                        </p>

                        {/*<a href="#user" className="prefs-btn" title={this.translate('settings')}>
                            <img src={require("../img/nav/i_go.svg").default} alt={this.translate('settings')}/>
                        </a>*/}
                    </div>

                    <div className="logoff">
                        <a href="logoff.html" onClick={this.logout} title={this.translate('logoff')}>{this.translate('logoff')}</a>
                    </div>
                </div>
                {/*<!-- /Usernav -->*/}

                {/*<!-- Panel Kontoeinstellungen -->*/}
                <div className="prefs-panel" style={{display: 'block'}}>
                    <div className="prefs-panel-container">
                        <div className="prefs-panel-content">
                            <div className="modules">
                                {/*<!-- Icons top index -->*/}
                                {/*<!-- <div className="panelseldownbase"><div className="panelseldown">Formulare einblenden</div></div> -->*/}
                                <div className="panelseldownbase">&nbsp;</div>

                                <div className="panelseldown">{this.translate('showForms')}</div>

                                <div className="circle-border" id="usericon">
                                    <img src={require('../img/nav/i_user.svg').default} alt={this.translate('user')} />
                                </div>

                                <div>
                                    <img className="panelicon envelope" src={require('../img/nav/i_mail.svg').default} alt={this.translate('email')} />
                                    <img className="panelicon globe" src={require('../img/nav/i_timezone.svg').default} alt={this.translate('timezone')} />
                                    <img className="panelicon key" src={require('../img/nav/i_password.svg').default} alt={this.translate('password')} />
                                </div>
                                {/*<!-- / Icons top index -->*/}

                                {/*<!-- select Headline -->*/}
                                <div className="selectheadline">
                                    <div className="openusericon">&nbsp;</div>
                                    <p className="prefs-panel-close">{this.translate('userSettings')}</p>
                                    <a href="#0" className="prefs-panel-close" id="closebtn">{this.translate('close')}</a>
                                </div>
                                {/*<!-- / select Headline -->*/}

                                {/*<!-- Form Elements -->*/}
                                <div className="formpanel closed" id="formpanel">
                                    <form action="action.php" method="post">
                                        <div className="component">
                                            <input id="settingsFirstname"
                                                   defaultValue={this.translate('firstName')}
                                                   type="text"
                                            />

                                            <input id="settingsLastname"
                                                   defaultValue={this.translate('lastName')}
                                                   type="text"
                                            />
                                        </div>

                                        <div className="component">
                                            <input id="settingsEmail"
                                                   defaultValue={this.translate('firstName') + '.' + this.translate('lastName') +'@' + this.translate('domain') + '.tld'}
                                                   type="text"
                                            />
                                        </div>

                                        <div className="component">
                                            <select id="timezoneSelect" size="1">
                                                <optgroup label="AFRICA">
                                                    <option value="Africa/Abidjan">Africa/Abidjan UTC+00:00</option>
                                                    <option value="Africa/Accra">Africa/Accra UTC+00:00</option>
                                                    <option value="Africa/Addis_Ababa">Africa/Addis_Ababa UTC+03:00</option>
                                                    <option value="Africa/Algiers">Africa/Algiers UTC+01:00</option>
                                                </optgroup>
                                                <optgroup label="AMERICA">
                                                    <option value="America/Adak">America/Adak UTC-09:00</option>
                                                    <option value="America/Anchorage">America/Anchorage UTC-08:00</option>
                                                    <option value="America/Anguilla">America/Anguilla UTC-04:00</option>
                                                    <option value="America/Antigua">America/Antigua UTC-04:00</option>
                                                    <option value="America/Araguaina">America/Araguaina UTC-03:00</option>
                                                    <option value="America/Argentina/Buenos_Aires">America/Argentina/Buenos_Aires UTC-03:00</option>
                                                </optgroup>
                                            </select>
                                        </div>

                                        <div className="component">
                                            <input id="settingsPassword" defaultValue="--unchanged--" type="password"/>
                                        </div>

                                        <div className="component">
                                            <input id="settingsPasswordValidation" defaultValue="--unchanged--" type="password"/>
                                        </div>

                                        <input defaultValue={this.translate('save')}
                                               data-i18n="[value]save"
                                               type="button"
                                               className="save"
                                        />

                                        <input defaultValue={this.translate('cancel')}
                                               data-i18n="[value]cancel" type="button" className="reset"
                                        />
                                    </form>
                                </div>
                                {/*<!-- / Form Elements -->*/}

                                <div className="subpanels">
                                    {/*<!-- select A: User Name -->*/}
                                    <div className="selectA">
                                        <p className="select" id="selectname">{this.translate('firstLastName')}</p>
                                    </div>
                                    {/*<!-- / select A: User Name -->*/}

                                    {/*<!-- select B: Email -->*/}
                                    <div className="selectB">
                                        <p className="select">{this.translate('firstName') + '.' + this.translate('lastName') +'@' + this.translate('domain') + '.tld'}</p>
                                    </div>
                                    {/*<!-- / select B: Email -->*/}

                                    {/*<!-- select B: Timezone -->*/}
                                    <div className="selectB">
                                        <p className="select">Europe / Berlin</p></div>
                                    {/*<!-- / select B: Timezone -->*/}

                                    {/*<!-- select B: Password -->*/}
                                    <div className="selectB password">
                                        <p className="select">***************</p>
                                    </div>
                                    {/*<!-- / select B: Password -->*/}
                                </div>
                            </div>

                            <div className="bg">&nbsp;</div>
                        </div>
                    </div>
                </div>
                {/*<!-- Dashboard Module oben -->*/}
            </div>
        );

    }

}

export default UserNav;